import { keepPreviousData } from '@tanstack/react-query';
import { useQueryWithErrorHandler } from './useQueryWithErrorHandler';
import { IError, IPowerBIEmbedParams } from 'types';
import { useAuthClient } from './useAuthClient';
import { useError } from '../providers';
import { useMemo } from 'react';

const getPowerBIReportParamsKey = 'getPowerBIReportParamsKey';

interface IProps {
  organizationId: string;
}

export function usePowerBIReport({ organizationId }: IProps) {
  const authClient = useAuthClient();
  const { openModal } = useError();
  const getPowerBIReportParams = useMemo(() => {
    return `/api/v1/${organizationId}/PowerBiEmbed/GetEmbedParams`;
  }, [organizationId]);

  return useQueryWithErrorHandler<IPowerBIEmbedParams, IError>({
    queryKey: [getPowerBIReportParamsKey, organizationId],

    queryFn: async () => {
      return await authClient(`${getPowerBIReportParams}`, {
        method: 'GET',
      });
    },

    enabled: true,
    refetchOnWindowFocus: false,

    onError: error => {
      openModal(error);
    },

    placeholderData: keepPreviousData,
  });
}
